import client from '../httpClient';

const schedulesGetActionWeekApi = (divisionId, actionDate) => {
  return client.get(`/schedules/week/${divisionId}?scheduleActionDate=${actionDate}`);
};

export default schedulesGetActionWeekApi;
